export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_002.5e37f9d9.jpg";